/**
 * Industry Constants
 * Centralized list of all available industries
 */

export const INDUSTRIES = [
  'Technology',
  'Healthcare',
  'Finance',
  'Retail',
  'E-commerce',
  'Manufacturing',
  'Software & IT Services',
  'Fintech',
  'Biotech',
  'Medical Devices',
  'Pharmaceuticals',
  'Insurance',
  'Real Estate',
  'Education',
  'Consulting',
  'Telecommunications',
  'Automotive',
  'Energy',
  'Transportation',
  'Hospitality'
];

export const INDUSTRY_CATEGORIES = {
  TECH: ['Technology', 'Software & IT Services', 'Telecommunications'],
  HEALTHCARE: ['Healthcare', 'Biotech', 'Medical Devices', 'Pharmaceuticals'],
  FINANCE: ['Finance', 'Fintech', 'Insurance'],
  RETAIL: ['Retail', 'E-commerce'],
  OTHER: ['Manufacturing', 'Real Estate', 'Education', 'Consulting', 'Automotive', 'Energy', 'Transportation', 'Hospitality']
};
